// Pdf.js

import React, { useEffect, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';

// ✅ react-pdf@5.7.2 : seul celui-ci est nécessaire pour rendre les liens cliquables
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';

import './Pdf.css';

import GetAppIcon from '@material-ui/icons/GetApp';
import { AppBar, Toolbar } from '@material-ui/core';
import { Col } from 'react-bootstrap';
import { MetroSpinner } from 'react-spinners-kit';
import { useTranslation } from 'react-i18next';
import { buildShapperPath } from '../../../helpers/Tools';
import { useSelector } from 'react-redux';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export default function Pdf(props) {
    const application = useSelector((state) => state.application);
    const { t } = useTranslation();

    const [totalPages, setTotalPages] = useState(null);
    const [errorLoading, setErrorLoading] = useState(false);
    const [loading, setLoading] = useState(true);

    const maxWidthRaw = application?.getApp?.webParams?.content_max_width;
    const maxWidth = maxWidthRaw ? parseFloat(maxWidthRaw) : null;

    const initialWidth =
        maxWidth && window.innerWidth >= maxWidth ? maxWidth : window.innerWidth;

    const [width, setWidth] = useState(initialWidth);
    const [height, setHeight] = useState(window.innerHeight);

    const url = buildShapperPath(props.dataPage.media_url);

    function onDocumentLoadSuccess({ numPages }) {
        setTotalPages(numPages);
        setLoading(false);
    }

    function onDocumentLoadError(error) {
        console.log(error);
        setLoading(false);
        setErrorLoading(true);
    }

    function updateDimensions(currentMaxWidth) {
        setWidth(
            currentMaxWidth && window.innerWidth >= currentMaxWidth
                ? parseFloat(currentMaxWidth)
                : window.innerWidth
        );
        setHeight(window.innerWidth < 800 ? window.innerHeight : window.innerHeight - 200);
    }

    useEffect(() => {
        // IMPORTANT: addEventListener attend une fonction, pas le résultat d'une fonction
        const handleResize = () => updateDimensions(maxWidth);
        window.addEventListener('resize', handleResize);

        console.log(' %c ////////CONTENU-PDF////////', 'background: #222; color: #bada55');

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [maxWidth]);

    if (errorLoading) {
        return (
            <div style={{ textAlign: 'center' }}>
                {t('loading_alert_msg_err_retry')}
            </div>
        );
    }

    const items =
        totalPages &&
        Array.from(new Array(totalPages), (_, index) => (
            <Page
                key={`page_${index + 1}`}
                pageNumber={index + 1}
                width={width * (2 / 3)}
                height={height}
                className={'page_display'}
                renderAnnotationLayer={true}
                loading={
                    <div style={{ marginTop: '20px' }}>
                        <MetroSpinner size={40} color={'black'} loading={true} />
                    </div>
                }
            />
        ));

    return (
        <div className="pdf-container" style={{ height }}>
            {!loading && (
                <AppBar position="static" className="app-bar">
                    <Toolbar>
                        <Col md={11} sm={11} className="navigation">
                            {/* Navigation éventuelle ici */}
                        </Col>

                        <Col md={1} sm={1} className="download">
                            <a href={url} className="download" target="_blank" rel="noopener noreferrer">
                                <GetAppIcon />
                            </a>
                        </Col>
                    </Toolbar>
                </AppBar>
            )}

            <Document
                file={url}
                onLoadSuccess={onDocumentLoadSuccess}
                onLoadError={onDocumentLoadError}
                className={'document_display'}
                externalLinkTarget="_blank"
                externalLinkRel="noopener noreferrer"
                loading={
                    <div style={{ marginTop: '20px' }}>
                        <MetroSpinner size={40} color={'black'} loading={true} />
                    </div>
                }
            >
                {items}
            </Document>
        </div>
    );
}
